import { Button, Grid } from '@mui/material';
import { FormProvider, NestedValue, SubmitHandler, useForm } from 'react-hook-form';
import { PriorityItemDto } from '../../api';
import { ComboBoxOption } from '../../components/form/controls/ComboBox';
import { SelectionBox } from '../../components/form/react-hook-form-components';
import useEmployees from '../../hooks/useEmployees';
import useFormStyles from '../../styles/useFormStyles';
import { getComboBoxOptions } from '../../utils/Utils';

interface IReassignPrioritiesFormProps {
  onSubmit: (values: PriorityItemDto, operation: string) => void;
  onCancel: () => void;
  priority: PriorityItemDto;
  newID?: number;
}

interface IReassignPriorityFormFields {
  employee?: NestedValue<ComboBoxOption> | null;
  employeeID?: number;
  operation: 'Copy' | 'Move';
}

/**
 * The form for creating and updating projects
 */
function ReassignPriorityForm(props: IReassignPrioritiesFormProps) {
  const classes = useFormStyles();
  const { onSubmit, onCancel, priority, newID } = props;
  const { data: employees } = useEmployees();
  const methods = useForm<IReassignPriorityFormFields>();
  const { handleSubmit } = methods;

  /**
   * Submit form data
   * @param data form fields input data
   */
  const submit: SubmitHandler<IReassignPriorityFormFields> = data => {
    onSubmit(
      {
        ...priority,
        employeeID: newID ? newID : data.employee?.value ?? 0,
      },
      data.operation
    );
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submit)}>
        <Grid container spacing={1.5} width="25rem">
          {newID === undefined && (
            <Grid item xs={12}>
              <SelectionBox name={'employee'} label={'Employee'} options={getComboBoxOptions(employees)} required />
            </Grid>
          )}

          <Grid item container direction="row" justifyContent={newID ? 'center' : 'end'} spacing={1}>
            <Grid item>
              <Button
                variant="contained"
                size="large"
                type="submit"
                className={classes.submitButton}
                onClick={handleSubmit(data => {
                  data.operation = 'Move';
                  submit(data);
                })}
              >
                Move
              </Button>
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                size="large"
                type="submit"
                className={classes.submitButton}
                onClick={handleSubmit(data => {
                  data.operation = 'Copy';
                  submit(data);
                })}
              >
                Copy
              </Button>
            </Grid>

            <Grid item>
              <Button variant="outlined" color="neutral" size="large" onClick={onCancel}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
}

export default ReassignPriorityForm;
